module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/paperwalletemptyFgBlack.9112ff8b6067783c9668835d37da39ad.svg";